import axios from "axios"
import baseURL from "../config/api"

export const post_SendLeadershipSMS = async (groupId: number, leadershipGroupId: number, message: string, isUserType: boolean, userId: number, token: string) => {
    return await axios({
        url: `${baseURL}sms/SendLeadershipSMS/${groupId},${leadershipGroupId}`,
        method: "POST",
        params: {
            message,
            isUserType,
            userId
        },
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true
    }).then(response => response.data);
}

export const post_SendMinistrySMS = async (groupId: number, subgroupId: number, message: string, isUserType: boolean, userId: number, token: string) => {
    return await axios({
        url: `${baseURL}sms/SendMinistrySMS/${groupId},${subgroupId}`,
        method: "POST",
        params: {
            message,
            isUserType,
            userId
        },
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true
    }).then(response => response.data);
}
